import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6" }
const _hoisted_2 = { class: "input-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*", -1)
const _hoisted_4 = {
  for: "additionalDiseases",
  class: "radio-button form-radio-button"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_6 = { class: "radio-button form-radio-button" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_8 = { class: "error-message" }

import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import { useField } from 'vee-validate';
import AdditionalDiseasesDescriptionField from './AdditionalDiseasesDescriptionField.vue';
import HasCareField from './HasCareField.vue';


export default {
  __name: 'AdditionalDiseasesField',
  props: {
    isExtended: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default:
            'Czy choruje Pani na choroby przewlekłe lub posiada alergie/uczulenie na jakiekolwiek leki?',
    },
},
  setup(__props) {

const props = __props;



const { value, errorMessage } = useField('additionalDiseases');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.title) + " ", 1),
        _hoisted_3
      ]),
      _createVNode(_unref(RadioGroup), {
        class: "radio-group",
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_isRef(value) ? (value).value = $event : null))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(RadioGroupOption), {
            class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
            value: "yes"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  id: "additionalDiseases",
                  name: "additionalDiseases",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
                  type: "radio",
                  value: "yes"
                }, null, 512), [
                  [_vModelRadio, _unref(value)]
                ]),
                _hoisted_5,
                _createTextVNode(" Tak ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(RadioGroupOption), {
            class: "cursor-pointer flex items-center justify-start font-medium",
            value: "no"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  name: "additionalDiseases",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null)),
                  value: "no",
                  type: "radio"
                }, null, 512), [
                  [_vModelRadio, _unref(value)]
                ]),
                _hoisted_7,
                _createTextVNode(" Nie ")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(errorMessage)), 1)
    ]),
    (_unref(value) === 'yes' && __props.isExtended)
      ? (_openBlock(), _createBlock(AdditionalDiseasesDescriptionField, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'yes' && __props.isExtended)
      ? (_openBlock(), _createBlock(HasCareField, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}